import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/globalVariables'
import axios from 'axios'

const API_URL = global.API_URL + 'users/'
const user = JSON.parse(localStorage.getItem('user'))

const initialState = {
    user: user ? user : null,
    allUsers: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const addNewUser = createAsyncThunk('auth/anu', async (userData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'addNewUser', userData)
        getAllUsers()
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const login = createAsyncThunk('auth/login', async (userData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'loginUser', userData)
        if (result.data.message) {
            global.msgError = result.data.message
        } else {
            global.msgError = ''
            localStorage.setItem('user', JSON.stringify(result.data))
        }
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAllUsers = createAsyncThunk('auth/gau', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getAllUsers')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteUser = createAsyncThunk('auth/du', async (userData, thunkAPI) => {
    console.log('reach')
    try {
        const result = await axios.post(API_URL + 'deleteUser', userData)
        console.log(result.data)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const logOut = createAsyncThunk('auth/logout', async () => { localStorage.removeItem('user') })

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
            state.user = null
            state.allUsers = []
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.isLoading = true
            })
            .addCase(login.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.user = action.payload
            })
            .addCase(login.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.user = null
            })
            .addCase(getAllUsers.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllUsers.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.allUsers = action.payload
            })
            .addCase(getAllUsers.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.allUsers = null
            })
            .addCase(deleteUser.pending, (state) => {
                state.isLoading = true
            })
            .addCase(deleteUser.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.message = action.payload
            })
            .addCase(deleteUser.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(logOut.fulfilled, (state) => {
                state.user = null
            })
    }
})

export const { reset } = authSlice.actions

export default authSlice.reducer